import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrosswordService } from '../crossword.service';
import { CrosswordWordModel } from '../models/crossword-word.model';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';
import { CrosswordArrowClassesEnum } from '../models/crossword-arrow-classes.enum';
import { CrosswordTileModel } from '../models/crossword-tile.model';
import { CrosswordBoardConfig } from '../crossword-board/crossword-board.component';

@Component({
  selector: 'lib-app-definition-tile',
  templateUrl: './definition-tile.component.html',
  styleUrls: ['./definition-tile.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class DefinitionTileComponent {
  // I don't know why the font loading was waiting for the init, but it seems to work without.
  // It was triggering the updateDefinitionSpacings() twice, which does not seem to be necessary.
  // TODO If you find this in the future an no one complained, remove it.
  // private initialized = false;
  // private fontLoaded = false;

  arrowDirectionClasses: CrosswordArrowClassesEnum[];

  @Input() tile: CrosswordTileModel;
  @Input() crosswordBoardConfig: CrosswordBoardConfig;
  @Input() wordSelected = false;
  @Output() definitionClicked = new EventEmitter<CrosswordWordModel>();

  private dragging: boolean;

  constructor(
    private crosswordService: CrosswordService,
    private elementRef: ElementRef,
    private helperFunctions: HelperFunctionsService,
    private el: ElementRef
  ) {
    // This resolves as true when the font is loaded.
    // Only then the proper spacing can be calculated.
    // If customDefinitionTileFont is defined in the config, that is used.
    this.crosswordService.definitionFontLoaded$.subscribe((loaded) => {
      // I don't know why the font loading was waiting for the init, but it seems to work without.
      // It was triggering the updateDefinitionSpacings() twice, which does not seem to be necessary.
      // TODO If you find this in the future an no one complained, remove it.
      // this.fontLoaded = true;
      // if (this.initialized) {
      if (loaded) {
        this.updateDefinitionSpacings();
      }
      // }
    });
  }

  /**
   * Listener for the onMouseDown event
   * Prevents click when dragging the puzzle field
   */
  onMouseDown(event: MouseEvent) {
    this.dragging = false;
    let mouseIsDown = true;

    const startPosition = {
      x: event.clientX,
      y: event.clientY,
    };

    const onMouseMove = (e) => {
      const position = {
        x: e.clientX,
        y: e.clientY,
      };
      if (mouseIsDown) {
        const offsetX = Math.abs(position.x - startPosition.x);
        const offsetY = Math.abs(position.y - startPosition.y);
        if (Math.sqrt(Math.pow(offsetY, 2) + Math.pow(offsetX, 2)) > 5) {
          this.dragging = true;
        }
      }
    };

    const onMouseUp = () => {
      mouseIsDown = false;
      // this.dragging = false;
      this.el.nativeElement.removeEventListener('mousemove', onMouseMove);
      this.el.nativeElement.removeEventListener('mouseup', onMouseUp);
    };

    this.el.nativeElement.addEventListener('mousemove', onMouseMove);
    this.el.nativeElement.addEventListener('mouseup', onMouseUp);
  }

  private updateDefinitionSpacings() {
    const spacings = [];
    const elements = [];

    let containerOffsetWidth = 43;

    /* this seems to make it worse
    if (this.helperFunctions.isIOS()) {
      containerOffsetWidth = 50;
    }
    */

    const definitionLines = this.elementRef.nativeElement.querySelectorAll('.definition-line-content');

    for (const definitionLine of definitionLines) {
      definitionLine.style.letterSpacing = '0';

      const lineOffsetWidth = definitionLine.offsetWidth;
      if (containerOffsetWidth < lineOffsetWidth) {
        let letterSpacing = (containerOffsetWidth - lineOffsetWidth) / (definitionLine.innerText.length - 1);
        // Round down to one comma digit
        letterSpacing = Math.round(letterSpacing * 10) / 10;
        elements.push(definitionLine);
        spacings.push(letterSpacing);
      }
    }

    for (let i = 0; i < elements.length; i++) {
      const singleWord = elements[i];
      singleWord.style.letterSpacing = '' + spacings[i] + 'px';
    }
  }

  onDefinitionClicked($event: MouseEvent, word: CrosswordWordModel) {
    if (this.dragging) {
      return;
    }
    $event.preventDefault();
    $event.stopPropagation();
    this.definitionClicked.emit(word);
  }
}
